import React, { useState, useEffect } from 'react'
import Wrapper from '../components/Wrapper'
import CloseIcon from "@mui/icons-material/Close";
import { global, input } from "../translate";
import { useSelector, useDispatch } from "react-redux";
import { userCrmRequest } from '../store/actions/users';
import { useNavigate } from 'react-router-dom';
import Api from "../Api";
import { Helmet } from 'react-helmet';
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TableFooter } from '@mui/material';
import Loader from '../components/Loader';
import { toast } from 'react-toastify';

export default function Rezx() {
    const [loading, setLoading] = useState(false)
    const [sip, setSip] = useState([])
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const userData = useSelector((state) => state.users.crmData)
    const handleSave = async (buddy) => {
        try {
            const {data} = await Api.createRezxSip(buddy)
            setSip((prev) => prev.map(p => {
                if (+p.buddy === +buddy) {
                    p.isInstalled = {id: data.crm.id, sip,redirect_call: 0}
                }
                return p
            }))
            toast.success('Success')
        } catch (e) {
        }
    }
    const handleDelete = async (id, sip) => {
        try {
            await Api.deleteRezxSip(id)
            toast.success('Success')
            setSip((prev) => prev.map(p => {
                if (+p.buddy === +sip) {
                    p.isInstalled = {}
                }
                return p
            }))
        } catch (e) {
        }
    }
    useEffect(() => {
        (async () => {
            await dispatch(userCrmRequest())
        })()
    }, [])
    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.getRezxSip()
                setSip(data?.sip)
            } catch (e) {
            }
        })()
    }, []);
    return (
        <>
            <Helmet>
                <title>
                    Rezx
                </title>
            </Helmet>
            <Wrapper>
                {loading ? <div className="loaderContainer"><Loader /></div> :
                    <div className="tableParent" id="tableParent">
                        <Paper sx={{ minWidth: 'fit-content', fontSize: 10 }}>
                            <TableContainer
                            >
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow className="sip_header">
                                            <TableCell sx={{ fontSize: 20, }} align="left" colSpan={9}>
                                                Key - {userData?.rezx?.access_token}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow className="sip_num">
                                            <TableCell align='center'>
                                                SIP
                                            </TableCell>
                                            <TableCell align='center'>
                                                Name
                                            </TableCell>
                                          
                                            <TableCell
                                                align='center'
                                            >
                                                Action
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody id="dataBody">
                                        {sip.length ? sip.map((s, _) => (
                                            <TableRow key={_} hover style={{ cursor: 'pointer' }} role="checkbox"
                                                tabIndex={-1}>
                                                <TableCell align="center">
                                                    {s.buddy}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {s.notes}
                                                </TableCell>
                                            

                                                <TableCell>
                                                    <div className="d-flex justify-content-center">
                                                        {!s.isInstalled?.id ?
                                                            <button onClick={() => handleSave(s.buddy,)}
                                                                className="addBtn">
                                                                Save
                                                            </button> : <button
                                                                onClick={() => handleDelete(s.isInstalled.id, s.buddy)}
                                                                className="deleteBtn">
                                                                Delete
                                                            </button>}
                                                    </div>

                                                </TableCell>
                                            </TableRow>

                                        )) : <TableRow hover role="checkbox" tabIndex={-1}>


                                            <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                                no data

                                            </TableCell>


                                        </TableRow>
                                        }

                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                                <div style={{ margin: 10 }} className="crm_save_btn" />
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </div>}
            </Wrapper>
        </>
    )
}
